import { injectable } from "tsyringe";
import { ISimLookupRepository } from "../domain/repositories/ISimLookupRepository";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { SimLookupRequestModel } from "./model/SimLookupRequestModel";
import { SimLookupResponseModel } from "./model/SimLookupResponseModel";
import client from "api/client";
import { SUPPORT_FEATURE } from "api/ApiPath";

@injectable()
export class SimLookupImpl implements ISimLookupRepository {
  async viewSim(
    params: SimLookupRequestModel
  ): Promise<BaseApiResponseModel<SimLookupResponseModel>> {
    return await client?.get(SUPPORT_FEATURE.VIEW_SIM, params);
  }
}